// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M12 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
    />
  </BaseIcon>
)
